import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`max-w-watchesMax mx-auto`};
  ${({ $flush }) => $flush && tw`max-w-watchesMaxFlush`}};

  & > * {
    display: block !important;
  }
`
